<template>
  <div class="case-studies" ref="studies">
    <div class="case-studies--header container">
      <Heading text="Projects" accent shuffle spaced loop glow type="h1" />
      <div class="case-studies--excerpt">
        <Heading text="Portfolio" glow spaced type="h2" />
        <p class="eyebrow">
          A collection of my work bringing brands and creative visions to life,
          from small to large scale. A wide range from interactive Web, to
          Enterprise solutions, to self-made projects.
        </p>
      </div>
    </div>
    <ProjectGrid ref="grid" />
    <CallToAction
      title="About Me"
      href="/about"
      text="Learn more about who I am and the type of mindsets I bring to creative challenges and projects."
      buttonLabel="About Me"
    />
  </div>
</template>

<script>
import Heading from "@/components/Heading";
import ProjectGrid from "@/components/ProjectGrid";
import CallToAction from "@/components/CallToAction";
import { useTransitionComposable } from "../../composables/transition-composable";
import { ref, watch, onUnmounted, onMounted } from "vue";
import { gsap } from "gsap";

const { transitionState } = useTransitionComposable();

export default {
  name: "Projects",
  metaInfo: {
    title: `Projects`,
    meta: [
      {
        name: "description",
        content: `A collection of all Lucas' web development, UI & UX, and interactive projects throughout the years.`,
      },
    ],
  },
  data() {
    return {
      scrollTriggerHeader: null,
      transitionStateTest: "",
    };
  },
  components: {
    Heading,
    ProjectGrid,
    CallToAction,
  },
  setup() {
    const studies = ref(null);
    const grid = ref(null);
    const ctx = ref();
    let mounted = false;
    watch(
      [() => transitionState.transitionComplete, studies],
      (newValue) => {
        if (newValue[0] == true && studies.value) {
          if (!mounted) {
            ctx.value = gsap.context(() => {
              const csTl1 = gsap.timeline();
              csTl1.to(".case-studies--header h1", {
                yPercent: 30,
                scrollTrigger: {
                  invalidateOnRefresh: true,
                  trigger: ".case-studies--header",
                  start: "-30% -30%", // when the top of the trigger hits the top of the viewport
                  scrub: true, // smooth scrubbing, takes 1 second to "catch up" to the scrollbar
                },
              });
              let mm = gsap.matchMedia();
              mm.add(
                {
                  isDesktop: `(min-width: 1400px)`,
                  isTablet: "(min-width: 768px)",
                },
                (context) => {
                  let { isDesktop } = context.conditions;
                  // '.project-grid .project-grid--item:nth-child(3n + 2)'
                  csTl1.to(
                    isDesktop
                      ? ".project-grid .project-grid--item:nth-child(3n + 2)"
                      : ".project-grid .project-grid--item:nth-child(odd)",
                    {
                      y: 100,
                      scrollTrigger: {
                        trigger: ".project-grid",
                        start: -25, // when the top of the trigger hits the top of the viewport
                        scrub: 1, // smooth scrubbing, takes 1 second to "catch up" to the scrollbar
                      },
                      ease: "none",
                    },
                  );
                  // '.project-grid .project-grid--item:nth-child(3n + 1)'
                  csTl1.to(
                    isDesktop
                      ? ".project-grid .project-grid--item:nth-child(3n + 1)"
                      : ".project-grid .project-grid--item:nth-child(even)",
                    {
                      y: -100,
                      scrollTrigger: {
                        trigger: ".project-grid",
                        start: -10, // when the top of the trigger hits the top of the viewport
                        scrub: 1, // smooth scrubbing, takes 1 second to "catch up" to the scrollbar
                      },
                    },
                  );
                },
              );
            });
            mounted = true;
          }
        }
      },
      {
        immediate: true,
      },
    );
    onMounted(() => {
      let mm = gsap.matchMedia();
      mm.add(
        {
          isDesktop: `(min-width: 1400px)`,
          isTablet: "(min-width: 768px)",
        },
        (context) => {
          let { isDesktop } = context.conditions;
          const csTl = gsap.timeline();
          csTl.fromTo(
            ".case-studies--header h1",
            { y: 100, opacity: 0 },
            {
              y: isDesktop ? 50 : 20,
              opacity: 0.15,
              duration: 1,
            },
          );

          csTl.fromTo(
            ".case-studies--excerpt",
            { y: 70, opacity: 0 },
            {
              y: 0,
              opacity: 1,
              duration: 1,
            },
            "-=0.85",
          );
        },
      );
    });
    onUnmounted(() => {
      // ctx.value.revert(); // <- Easy Cleanup!
    });
    return { studies, grid }; // WILL NOT WORK WITHOUT THIS
  },
  methods: {},
};
</script>
